import { useEffect, useState } from "react";
import Image from "next/image";

export const ScrollIndicator = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const checkVisibility = () => {
      const viewportHeight = window.innerHeight;
      const hasScrolled = window.scrollY > 0;
      
      setIsVisible(viewportHeight <= 1200 && !hasScrolled);
    };

    checkVisibility();

    window.addEventListener("resize", checkVisibility);
    window.addEventListener("scroll", checkVisibility);

    return () => {
      window.removeEventListener("resize", checkVisibility);
      window.removeEventListener("scroll", checkVisibility);
    };
  }, []);

  const handleClick = () => {
    setIsAnimating(true);
    window.scrollTo({
      top: window.scrollY + 500,
      behavior: "smooth"
    });
    setTimeout(() => setIsAnimating(false), 600);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div 
      className={`fixed bottom-4 left-4 z-50 cursor-pointer transition-transform duration-300 ${isAnimating ? 'animate-bounce' : 'animate-pulse'}`}
      onClick={handleClick}
    >
      <Image
        src="/762338.png"
        alt="スクロールしてください"
        width={40}
        height={40}
        layout="fixed"
        quality={100}
      />
    </div>
  );
};
